/**
 * HubSpot configuration for the SRL Advisor contact form.
 *
 * The form posts directly to the HubSpot Forms Submissions API v3 (no embed
 * script). Sourced from the HubSpot embed snippet:
 *
 *   <div class="hs-form-frame"
 *        data-region="na2"
 *        data-form-id="ae558d86-2341-4890-8d51-72221c749962"
 *        data-portal-id="244482894"></div>
 */

export const HUBSPOT_PORTAL_ID = '244482894';
export const HUBSPOT_FORM_ID = 'ae558d86-2341-4890-8d51-72221c749962';
export const HUBSPOT_REGION = 'na2';

export function isHubspotConfigured() {
    return (
        typeof HUBSPOT_PORTAL_ID === 'string' &&
        typeof HUBSPOT_FORM_ID === 'string' &&
        !HUBSPOT_PORTAL_ID.startsWith('TODO_') &&
        !HUBSPOT_FORM_ID.startsWith('TODO_')
    );
}
